<div class="header">
    <h2 style="text-align: center;">System Status Dashboard</h2>
    <div>Last updated: {{ lastUpdated }}</div>
</div>

<!-- Summary Cards -->
<div class="summary-grid">

    <div class="card">
        <div class="title">App Log Lines</div>
        <div class="value">{{ appLines }}</div>
    </div>

    <div class="card">
        <div class="title">Apache Requests</div>
        <div class="value">{{ apacheRequests }}</div>
    </div>

    <div class="card">
        <div class="title">System Log Lines</div>
        <div class="value">{{ systemLines }}</div>
    </div>

    <div class="card">
        <div class="title">App Errors</div>
        <div class="value">{{ appErrors }}</div>
    </div>

    <div class="card">
        <div class="title">High Alerts</div>
        <div class="value">{{ highAlerts }}</div>
    </div>

</div>

<!-- CHARTS GRID -->
<div class="charts-grid">

    <div class="chart-card">
        <h4>App Severity</h4>
        <canvas id="chartAppSeverity"></canvas>
    </div>

    <div class="chart-card">
        <h4>App Hourly Errors</h4>
        <canvas id="chartAppHourly"></canvas>
    </div>

    <div class="chart-card">
        <h4>Apache Status Codes</h4>
        <canvas id="chartApacheCodes"></canvas>
    </div>

    <div class="chart-card">
        <h4>Apache Top Endpoints</h4>
        <canvas id="chartApacheTop"></canvas>
    </div>

    <div class="chart-card">
        <h4>System Severity</h4>
        <canvas id="chartSystemSeverity"></canvas>
    </div>

    <div class="chart-card">
        <h4>System Errors by Unit</h4>
        <canvas id="chartSystemUnits"></canvas>
    </div>

    <div class="chart-card">
        <h4>CPU / Memory Trend</h4>
        <canvas id="chartCpuMemTrend"></canvas>
    </div>

    <div class="chart-card">
        <h4>Disk Usage</h4>
        <canvas id="chartDiskUsage"></canvas>
    </div>

</div>